export default "__VITE_ASSET__BO57gm0o__"